// import utils from '../utils/utils'
import '../utils/axiosConfig' // axios配置文件

export default {
  common: {
    sendSmsCode (params, success, error) {
      $axios.get('common/sendSmsCode', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    checkSmsCode (params, success, error) {
      $axios.get('common/checkSmsCode', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getTree (params, success, error) {
      $axios.get('region/getTree', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    areaTree (params, success, error) {
      $axios.get('region/getSuiningTree', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  index: {
    search (params, success, error) {
      $axios.get('index/search', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  news: {
    newsList (params, success, error) {
      $axios.get('infoArticle/list', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    newsADList (params, success, error) {
      $axios.get('infoArticle/listWithFullText', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    newsDetail (params, success, error) {
      $axios.get(`infoArticle/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },

    newsReadOrLike (id, type, success, error) {
      // 请求阅读接口  type: 1 表示 点赞   2  表示阅读 3 同时
      $axios.post(`infoArticle/doSth/${id}/${type}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  organization: {
    listDepartments (params, success, error) {
      $axios.get('organization/listDepartments', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceOrg (params, success, error) {
      $axios.post('organization/applyServiceOrg', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceOrgList (params, success, error) {
      $axios.get('organization/listServiceOrg', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    listInteliOrg (params, success, error) {
      $axios.get('organization/listInteliOrg', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    joinOrg (params, success, error) {
      $axios.get('user/joinOrg', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    companyOrg (params, success, error) {
      $axios.post('organization/applyCompanyOrg', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    companyOrgList (params, success, error) {
      $axios.get('organization/listCompanyOrg', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    orgDetail (params, success, error) {
      $axios.get(`organization/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    OrgUserList (params, success, error) {
      $axios.get('organization/getUsersOfOrg', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    addUserOrg (params, success, error) {
      $axios.post('user/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    delUserOrg (params, success, error) {
      $axios.delete('user/delete', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditUsersJoining (params, success, error) {
      $axios.post('organization/auditUsersJoining', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  config: {
    list (params, success, error) {
      $axios.get('codeConfig/list', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getConfigList (code, success, error) {
      $axios.get('codeConfig/tree/' + code).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    listTree (params, success, error) {
      $axios.get('codeConfig/listWithMoreLevel', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`codeConfig/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    configParams_1 (params, success, error) {
      $axios.get('codeConfig/listWithOneLevel', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    industryCodeList (params, success, error) {
      $axios.get('codeConfig/listWithOneLevel', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    configParams_2 (params, success, error) {
      $axios.get('codeConfig/listWithMoreLevel', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    bannerList (params, success, error) {
      $axios.get(`banner/lisPages`, { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    outerProList (params, success, error) {
      $axios.get('outerPro/list', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  policy: {
    list (params, success, error) {
      $axios.get('policyArticle/market', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`policyArticle/market/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    apply (params, success, error) {
      $axios.post('submitForm', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyCheck (params, success, error) {
      $axios.get('submitForm/check', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyDetail (params, success, error) {
      $axios.get(`submitForm/${params.id}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyEdit (params, success, error) {
      $axios.put(`submitForm/${params.id}`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myApply (params, success, error) {
      $axios.get('submitForm/market/own', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  account: {
    login (params, success, error) {
      $axios.post('user/login', params).then((res) => {
        success && success(res.data)
        $axios.defaults.headers.common['authKey'] = res.data.data.authKey // 登录成功后，设置默认请求头
      }).catch((err) => {
        error && error(err)
      })
    },
    // 未读消息
    msgCounts (params, success, error) {
      $axios.get('user/msgCounts', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    logout (params, success, error) {
      $axios.get('user/logout', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    resetPwd (params, success, error) {
      $axios.get('', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    register (params, success, error) {
      $axios.post('user/registry', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    findPwd (params, success, error) {
      $axios.put('user/findPwd', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`user/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    edit (params, success, error) {
      $axios.put('user/update', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    checkAuthkey (params, success, error) {
      $axios.get('user/expired', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  formTemplate: {
    detail (params, success, error) {
      $axios.get(`template/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  file: {
    upload (params, success, error) {
      $axios.post('file/upload', params,
        { 'Content-Type': 'multipart/form-data' }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  approval: {
    auditOwnProject (params, success, error) {
      $axios.get('auditChain/market/ownProject', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditChainConfig (params, success, error) {
      $axios.get(`auditChain/market/ownProject/${params.policyId}`, {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditDetail (params, success, error) {
      $axios.get(`auditChain/detail`, { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditPass (params, success, error) {
      $axios.put(`auditChain/${params.id}/pass`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditRefuse (params, success, error) {
      $axios.put(`auditChain/${params.id}/refuse`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditReject (params, success, error) {
      $axios.put(`auditChain/${params.id}/reject`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    auditCacelReject (params, success, error) {
      $axios.put(`auditChain/${params.id}/cacelReject`, {
        params: params
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  statistics: {
    industryIndex (params, success, error) {
      $axios.get('statistics/finance', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    policyOrg (params, success, error) {
      $axios.get('statistics/policy/organization', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    policySupport (params, success, error) {
      $axios.get('statistics/policy/support', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    statisticsCount (params, success, error) { // 政策云统计
      $axios.get('statistics/policy', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    service (params, success, error) {
      $axios.get('statistics/service', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    demand (params, success, error) {
      $axios.get('statistics/demand', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceIndex (params, success, error) {
      $axios.get('statistics/service/base', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getCountForCompany (params, success, error) {
      $axios.get('statistics/getCountForCompany', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getCountForInnovate (params, success, error) {
      $axios.get('statistics/getCountForInnovate', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    countGroupbyType (params, success, error) { // 咨询云统计
      $axios.get('infoArticle/countGroupbyType', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getTrainCount (params, success, error) { // 培训云统计
      $axios.get('statistics/getTrainCount', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getCountForThinkTank (params, success, error) { // 智库云统计
      $axios.get('statistics/getCountForThinkTank', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    companyCount (params, success, error) { // 企业云统计
      $axios.get('statistics/getCountForCompany', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    statisticsDemandPatent (params, success, error) { // 创新云统计
      $axios.get('statistics/demand/patent', {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  subsidy: {
    subsidyList (params, success, error) {
      $axios.get('serviceTicket/pages', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serveList (params, success, error) { // 津贴里面得服务列表
      $axios.get('service/market/onticket', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    statictis (success, error) {
      $axios.get('statistics/tickets').then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`serviceTicket/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyDetail (params, success, error) {
      $axios.get(`applyTicket/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    add (params, success, error) {
      $axios.post('serviceTicket/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    edit (params, success, error) {
      $axios.post('serviceTicket/update', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    del (params, success, error) {
      $axios.delete('serviceTicket/delete', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyList (params, success, error) {
      $axios.get('applyTicket/pages', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    audit (params, success, error) {
      $axios.post('applyTicket/audit', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    apply (params, success, error) {
      $axios.post('applyTicket/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyTicketUpdate (params, success, error) {
      $axios.post('applyTicket/update', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    subsidyReportList (params, success, error) {
      $axios.get('serviceTicket/policyPages', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  service: {
    del (params, success, error) {
      $axios.delete(`service/${params.id}`, { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    applyServiceTicket (params, success, error) {
      $axios.get('organization/applyServiceTicket', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    market (params, success, error) {
      $axios.get('service/market', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`service/market/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    add (params, success, error) {
      $axios.post('serviceMainOrder', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myService (params, success, error) {
      $axios.get('service/own', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myDemandOrder (params, success, error) {
      $axios.get('/serviceMainOrder/demand/apply', {
        params: params
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myserviceOrderApply (params, success, error) {
      $axios.get('serviceMainOrder/organization', {
        params: params
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceMainOrderPass (params, success, error) {
      $axios.put(`serviceMainOrder/${params.id}/pass`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceMainOrderRefuse (params, success, error) {
      $axios.put(`serviceMainOrder/${params.id}/refuse`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceMainOrderFinish (params, success, error) {
      $axios.put(`serviceMainOrder/${params.id}/finish`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceComment (params, success, error) {
      $axios.post('serviceComment', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myAdd (params, success, error) {
      $axios.post('service/market', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myUpdate (params, success, error) {
      $axios.put(`service/market/${params.id}`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    online (params, success, error) {
      $axios.put(`service/${params.id}/online`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    offline (params, success, error) {
      $axios.put(`service/${params.id}/offline`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  demand: {
    del (params, success, error) {
      $axios.delete(`demand/${params.id}`, { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    market (params, success, error) {
      $axios.get('demand/market', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`demand/market/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    add (params, success, error) {
      $axios.post('demand/market', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    update (params, success, error) {
      $axios.put(`demand/market/${params.id}`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myDemand (params, success, error) {
      $axios.get('demand/own', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myDemandApplyList (params, success, error) {
      $axios.get('serviceMainOrder/demand/own', {
        params: params
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myServiceOrder (params, success, error) {
      $axios.get('/serviceMainOrder/own', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    online (params, success, error) {
      $axios.put(`demand/${params.id}/online`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    offline (params, success, error) {
      $axios.put(`demand/${params.id}/offline`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  serviceComment: {
    market (params, success, error) {
      $axios.get('serviceComment/market', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  msg: {
    list (params, success, error) {
      $axios.get('msg/listPage', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    listPageWithComment (params, success, error) {
      $axios.get('msg/listPageWithComment', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    add (params, success, error) {
      $axios.post('msg/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  companyPro: {
    list (params, success, error) {
      $axios.get(`companyPro/org/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  training: {
    list (params, success, error) {
      $axios.get('activity/pages', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    searchList (params, success, error) {
      $axios.get('activity/search', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`activity/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    add (params, success, error) {
      $axios.post('activity/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    update (params, success, error) {
      $axios.post(`activity/update`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    delete (params, success, error) {
      $axios.delete(`activity/delete`, {
        params: params,
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    join (params, success, error) {
      $axios.post('applyActivity/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myTraining (params, success, error) {
      $axios.get('user/myActivities', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getUsersOfPublisher (params, success, error) {
      $axios.get('activity/getUsersOfPublisher', {
        params: params
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    activityApplyList (params, success, error) {
      $axios.get('activity/applyRecords', {
        params: params
      }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getSubCount (params, success, error) {
      $axios.get('activity/getSubCount', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  thinkTank: {
    list (params, success, error) {
      $axios.get('expert/list', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`expert/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  productionCloud: {
    financingProductsList (params, success, error) {
      $axios.get('service/market/finance', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    loanServiceList (params, success, error) {
      $axios.get('service/market/credit', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    enterPriseProjectList (params, success, error) {
      $axios.get('service/market/project', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    demandFinance (params, success, error) {
      $axios.get('demand/finance', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    serviceMainOrderinance (params, success, error) {
      $axios.get('serviceMainOrder/finance', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  innovation: {
    achievementList (params, success, error) {
      $axios.get('result/list', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    achievementDetail (params, success, error) {
      $axios.get(`result/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    patentList (params, success, error) {
      $axios.get('patent/list', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    patentDetail (params, success, error) {
      $axios.get(`patent/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    patentRight (params, success, error) {
      $axios.get('patentRight/list', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    patentRightDetail (params, success, error) {
      $axios.get(`patentRight/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    rightsProtection (params, success, error) {
      $axios.post('patentRight/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    patentAdd (params, success, error) {
      $axios.post('patent/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    patentUpdate (params, success, error) {
      $axios.put(`patent/update`, params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    myRightsProtection (params, success, error) {
      $axios.get('user/myRightsProtection').then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  message: {
    myMsgs (params, success, error) {
      $axios.get('user/myMsgsPage').then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    msgListPage (params, success, error) {
      $axios.get('msg/listPage', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    readMsg (params, success, error) {
      $axios.post('msg/read', null, { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    delMsg (params, success, error) {
      $axios.post('msg/delete', null, { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  companyProduct: { // 企业产品
    detail (params, success, error) {
      $axios.get('companyPro/detail/' + params, {}).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    list (params, success, error) {
      $axios.get('companyPro', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    orgProlist (params, success, error) {
      $axios.get(`companyPro/org/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    add (params, success, error) {
      $axios.post('companyPro/market/add', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    edit (params, success, error) {
      $axios.put('companyPro/market/update', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    delete (params, success, error) {
      $axios.delete('companyPro/' + params.id).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  zhaobiao: {
    hotList (params, success, error) {
      $axios.get('index/firsetshow', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    zhaobiaoList (params, success, error) {
      $axios.get('bid/pageTop', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`bid/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    zhaobiaoListToken (params, success, error) {
      $axios.get('bid/page', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getCateList (params, success, error) {
      $axios.get('bid/getCateList', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getProvList (params, success, error) {
      $axios.get('bid/getProvList', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    getBusinessList (params, success, error) {
      $axios.get('bid/getBusinessList', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  procuct: {
    list (params, success, error) {
      $axios.get('companyPro/market', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    detail (params, success, error) {
      $axios.get(`/companyPro/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  },
  yq: {
    zj_list (params, success, error) {
      $axios.get('volunteerExperrt/page', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    zj_add (params, success, error) {
      $axios.post('volunteerExperrt/addorUpdate', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    zj_edit (params, success, error) {
      $axios.put('volunteerExperrt/addorUpdate', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    zj_delete (params, success, error) {
      $axios.delete('volunteerExperrt/delete?id=' + params.id).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    tips_list (params, success, error) {
      $axios.get('hint/page', { params: params }).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    tips_detail (params, success, error) {
      $axios.get(`hint/detail/${params}`).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    tips_add (params, success, error) {
      $axios.post('hint/addorUpdate', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    tips_edit (params, success, error) {
      $axios.put('hint/addorUpdate', params).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
    tips_delete (params, success, error) {
      $axios.delete('hint/delete?id=' + params.id).then((res) => {
        success && success(res.data)
      }).catch((err) => {
        error && error(err)
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js